export const filterSearchToQuery = (search: string): { search: string } => ({
  search,
});
